import { motion, type MotionValue } from 'framer-motion'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Interactive } from '@highlight/ui'
import { SidepanelCircularButton } from './circular-button'
import { TRIGGER_EDGE_INSET } from '@renderer/overlay/hooks/use-edge-trigger'
import type { SidepanelSide } from '@shared/sidepanel/side'

interface EdgePeekButtonProps {
  /** Horizontal slide position (px): off-edge when hidden → resting when slid in. */
  x: MotionValue<number>
  /** Which screen edge the affordance lives on (the sidepanel's anchored side). */
  side: SidepanelSide
  onClick: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

/**
 * The screen-edge peek affordance rendered by the sidepanel trigger
 * (`peek-trigger.tsx`).
 *
 * Pinned to vertical center; self-centering lives on the inner wrapper so it
 * doesn't fight the `x` translate on the positioned node. The chevron points
 * away from the edge (the direction the panel opens toward).
 */
export function EdgePeekButton({ x, side, onClick, onMouseEnter, onMouseLeave }: EdgePeekButtonProps) {
  const Chevron = side === 'right' ? ChevronLeft : ChevronRight
  return (
    <motion.div
      className="pointer-events-auto fixed top-1/2 z-40 cursor-pointer"
      style={{ [side]: TRIGGER_EDGE_INSET, x }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="-translate-y-1/2">
        <Interactive>
          <SidepanelCircularButton onClick={onClick} icon={<Chevron className="text-foreground size-6" />} />
        </Interactive>
      </div>
    </motion.div>
  )
}
